import { gql } from '@apollo/client/core'

export const productSearchQuery = gql`
  query skuSearch($categoryIds: [ID!], $minUnitPrice: Int, $maxUnitPrice: Int, $quantity: Int, $facets: [String!], $keyword: String!, $offset: Int!, $limit: Int!, $sortOrder: String!) {
    skuSearch(
      categoryIds: $categoryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      quantity: $quantity
      facets: $facets
      keyword: $keyword
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
    ) {
      totalItemsCount
      items {
        productId
        dOneImNumber
        id
        displayName
        minUnitPrice
        minCampaignUnitPrice
        maxUnitPrice
        maxCampaignUnitPrice
        minQuantity
        maxQuantity
        quantityUnit
        mainImage
        lotOptions {
          quantityPerLot
          price
        }
        categories {
          id
        }
      }
      facets {
        facetKeyName
        facetKeyId
        facetKeyDisplayName
        facetType
        canonicalSetting
        count
        facetKeyDisplayOrder
        facetValues {
          count
          facetValueName
          facetValueId
          facetValueDisplayOrder
          facetValueDisplayName
        }
      }
      categories {
        id
        topSearchCount
        childCategories {
          id
          topSearchCount
          childCategories {
            id
            topSearchCount
          }
        }
      }
      limit
      offset
    }
  }`

export const estimateProductSearchQuery = gql`
  query getEstimateSearchProducts(
    $categoryIds: [ID!]
    $minUnitPrice: Int!
    $maxUnitPrice: Int!
    $quantity: Int
    $facets: [String!]
    $offset: Int!
    $limit: Int!
    $sortOrder: String!
  ) {
    skuSearch(
      categoryIds: $categoryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      quantity: $quantity
      facets: $facets
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
    ) {
      totalItemsCount
    }
  }
`
